import API, { ensurePrefixed } from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import { padronesEnum } from 'views/Tramites/GPM/enums';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/giros-de-modulos/';

/**
 * GET Giros Comerciales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getGirosDeModulos = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Giro Comercial
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getGiroDeModulo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Giro Comercial
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postGiroDeModulo = async (values, accion = 'GIRO_DE_MODULO') => {
  try {
    const formattedValues = getFormattedValues(values);
    const accionInf = ensurePrefixed('CREAR_', accion);
    const response = await API.post(baseURI, formattedValues, {
      accionInf,
      idPadron: padronesEnum.MERCADO,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Giro Comercial
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchGiroDeModulo = async (id, values, accion = 'GIRO_DE_MODULO') => {
  try {
    const formattedValues = getFormattedValues(values, { clean: false });
    const accionInf = ensurePrefixed('EDITAR_', accion);
    const response = await API.patch(`${baseURI}${id}`, formattedValues, {
      accionInf,
      idPadron: padronesEnum.MERCADO,
      clave: formattedValues.clave,
    });
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Giro Comercial
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteGiroDeModulo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
